import React from "react";
import { withTheme } from "@material-ui/core";
import { getCurrentStop } from "../../../../utils/utils";
import { getDriverStatus } from "../../../utils/DriverStatus";
import { getDriverStatusIcon } from "../../../utils/DriverStatus/driverStatusIcon";

const DriverStatusIcon = (props) => {
  const { driverStatus, driverStatusLabel } = getDriverStatus(props, false);

  if (!driverStatusLabel) {
    return null;
  }

  const currentStop = getCurrentStop(props.data.currentStatus, props.data.stops);
  const driverStatusIcon = getDriverStatusIcon({
    driverStatus,
    currentStop,
    color: props.theme.palette.primary.main,
    delays: props.data?.delays,
  });

  return (
    <div className="driver-status-container">
      <div className="driver-status-icon-container">{driverStatusIcon}</div>
      <div className="driver-status-label">{driverStatusLabel}</div>
    </div>
  );
};

export default withTheme()(DriverStatusIcon);
